import { ChangeEvent, useState } from 'react'
import BrandedLogo from '../components/branded-logo'
import CustomInput from '../components/CustomInput'
import CustomButton from '../components/CustomButton'
import Loader from '../components/Loader'
import { toast } from 'react-toastify'
import { ParseErrors } from '../utils/ParseErrors'
import axiosInstance from '../utils/axiosInstance'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ResetPassword = () => {
    const navigation = useNavigate()
    const [values, setValues] = useState<any>({
        password: "",
        cpassword: "",
    })
    const [loading, setIsLoading] = useState(false)
    const [searchParams] = useSearchParams()
    const ref_id = searchParams.get("ref_id")

    // ------------------------------- [ HANDLE LOGIN ] -------------------------------
    const HandleResetPassword = async () => {
        if (Validate()) {
            setIsLoading(true)
            try {
                await axiosInstance.put(`/auth/reset-password/${ref_id}`, values)
                toast.success("Password Updated successfully")
                setIsLoading(false)
                navigation("/auth")
            } catch (error) {
                toast.error(ParseErrors(error))
                setIsLoading(false)
            }
        }
    }

    // ---------------------- [  VALIDATION FUNCTION ] ----------------------

    const Validate = () => {
        if (!values.password) {
            toast.error("Please enter a password")
            return false
        } else if (!values.cpassword) {
            toast.error("Please confirm your password")
            return false
        } else if (values.cpassword !== values.password) {
            toast.error("Password and Confirm Password must be same")
            return false
        } else {
            return true
        }
    }


    // ---------------------- [  ON INPUT CHANGE SET VALUES ] ----------------------
    const onChangeValues = (e: ChangeEvent<HTMLInputElement>) => {
        setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    const RedirectToLogin = () => {
        navigation("/auth")
    }

    return (
        <div className='w-[100%] h-[100vh] bg-background flex items-center justify-between'>
            {/* AUTH PAGE LOGO */}
            <div className="w-[45%] h-[100%] flex items-center justify-center relative" >
                <div className='h-[400px] w-[450px] blur-3xl rounded-[50%] bg-indigo-600/20 animate-pulse absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]'></div>
                <div className=" p-[30px] text-center border-r-[50%] relative animate-fade-in-slow">
                    <p className="text-[55px]">👋</p>
                    <h4 className="text-text-secondary text-[28px] font-medium">Welcome to</h4>
                    <BrandedLogo className="w-[300px] mt-2 h-[auto] object-cover mx-auto" />
                </div>
            </div>
            {/* AUTH PAGE LOGO */}


            {/* LOGIN AND RESET FORM */}


            <div className='w-[55%] h-full flex items-center justify-center'>
                <div className={`w-[55%] max-w-[430px] h-[480px] relative [perspective:1000px] `}>
                    <div className={`h-full w-full relative transition-all duration-500`}>

                        {/*------------------------------- LOGIN FORM --------------------- */}
                        <div className={`absolute inset-0 py-[40px] px-[50px] bg-surface border border-edge rounded-2xl shadow-overlay animate-fade-in`}>
                            <div className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-accent via-blue to-accent-bright rounded-t-2xl" />
                            <div >
                                <h2 className="text-center text-[26px] bg-gradient-heading bg-clip-text text-transparent font-heading-font">RESET PASSWORD</h2>
                                <div className=' my-8'>
                                    <CustomInput title="Password" label='Password' name='password' type='password' onChange={onChangeValues} />
                                    <div className='my-6'></div>
                                    <CustomInput title="Confirm Password" label='Confirm Password' name='cpassword' type='password' onChange={onChangeValues} />

                                    <CustomButton variant="primary" className='w-full mt-[55px] !text-base' onClick={HandleResetPassword}>{loading ? <Loader /> : "SUBMIT"}</CustomButton>
                                    <p className='text-base text-blue hover:text-accent-bright transition-colors font-medium cursor-pointer mt-6 text-center' onClick={RedirectToLogin}>Back to Login?</p>
                                </div>
                            </div>
                        </div>
                        {/*------------------------------- LOGIN FORM --------------------- */}



                    </div>
                </div>
            </div>




            {/* LOGIN AND RESET FORM */}
        </div>
    )
}

export default ResetPassword
